<template>
  <div
    @click.prevent="detectElement($event)"
    :class="{ 'todo-selected': activeId === todo.id }"
    class="cursor-pointer w-full todo-item border flex justify-between items-center rounded-lg p-5 py-8 mb-3"
  >
    <div class="flex justify-between w-full">
      <div>
        <checkbox id="check" :value="selected" class="mr-1 inline" />
        <span>{{ todo.todo_text }}</span>
      </div>

      <div class="">
        <span id="edit" class="cursor-pointer p-2 text-green-500"
          ><i id="edit" class="fas fa-edit text-lg"></i> Edit</span
        >
        <span id="delete" class="ml-2 cursor-pointer p-2 text-red-500"
          ><i id="delete" class="fas fa-trash-alt text-lg"></i> Delete</span
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["todo", "activeId"],
  data() {
    return {
      selected: this.todo.is_completed,
    };
  },
  components: {
    checkbox: () => import("@/components/forms/checkbox"),
  },
  computed: {
    done() {
      return this.completed;
    },
  },
  methods: {
    ...mapActions(["deleteTodo", "fetchTodos", "updateTodo"]),
    async detectElement(e) {
      if (e.target.id === "edit") {
        this.$router.push({
          name: "learner-todo-edit",
          params: { id: this.todo.id },
        });
        return;
      } else if (e.target.id === "delete") {
        this.$emit("delete-todo", this.todo.id);
        return;
      } else if (e.target.id === "checkbox") {
        this.selected = !this.selected;
        this.$emit("edit-todo", {
          id: this.todo.id,
          data: { is_completed: this.selected },
        });
        return;
      } else {
        this.$emit("set-active", this.todo);
        return;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.truncate {
  -o-line-clamp: 1;
  -ms-line-clamp: 1;
  -webkit-line-clamp: 1;
}
.todo-selected {
  border-color: color(lms-tenant) !important;
}
.deadline-passed {
  border-color: red;
}
</style>
